import React from 'react';
import PropTypes from 'prop-types';

const PlaylistAddPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M26 20.51a.507.507 0 0 0-.505-.51h-.99a.5.5 0 0 0-.505.51V24h-3.49a.507.507 0 0 0-.51.505v.99a.5.5 0 0 0 .51.505H24v3.49c0 .282.226.51.505.51h.99a.5.5 0 0 0 .505-.51V26h3.49c.282 0 .51-.226.51-.505v-.99a.5.5 0 0 0-.51-.505H26v-3.49zM16 25c0 .168.005.334.014.5H4.5A.5.5 0 0 1 4 25v-2a.5.5 0 0 1 .5-.5h11.852A9.005 9.005 0 0 0 16 25zm9-9c-1.488 0-2.891.36-4.127 1H4.5a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h23a.5.5 0 0 1 .5.5v2a.51.51 0 0 1 0 .012A8.985 8.985 0 0 0 25 16zM14.5 6h13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5zM4.25 3.01c0-.497.364-.658.81-.361l6.368 4.238c.448.298.425.753-.045 1.014l-6.278 3.482c-.472.262-.855.068-.855-.425V3.009zM25 32a7 7 0 1 1 0-14 7 7 0 0 1 0 14z"
    />
  );
};

PlaylistAddPath.propTypes = {
  fill: PropTypes.string,
};

export default PlaylistAddPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/video-features/playlist-add.jsx